import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
};
type Pixel = (command: 'track', event: 'InitiateCheckout', data: {
  content_name: string;
  value: number;
  currency: string;
}) => void;
export function CheckoutButton({
  children,
  className = ''
}: ButtonProps) {
  function trackCheckout() {
    const pixel = (window as Window & {
      fbq?: Pixel;
    }).fbq;
    pixel?.('track', 'InitiateCheckout', {
      content_name: 'Dance Fitness Instructor Pro Complete 7-in-1 System',
      value: 27,
      currency: 'USD'
    });
  }
  return <motion.a href="https://dance-fitness-instructor-pro.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" onClick={trackCheckout} whileHover={{
    scale: 1.025
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex min-h-12 items-center justify-center rounded-full border-2 border-transparent bg-orange px-7 py-3.5 text-center text-sm font-bold tracking-wide text-white shadow-[0_10px_20px_rgba(242,92,5,.22)] transition-colors hover:bg-orange-dark focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2 focus:ring-offset-white sm:px-9 sm:text-base ${className}`} data-id="element-38">
      {children}
    </motion.a>;
}